import type qrcode from "qrcode-generator";

export const qrConfig = {
	// 0 chooses the smallest QR version that fits the payload.
	version: 0,
	errorCorrection: "M",
	encoding: "Byte",
	content: "https://simonepiteo.com/",
	quietZoneModules: 4,
	fallbackModulePixels: 8,
} satisfies {
	version: Parameters<typeof qrcode>[0];
	errorCorrection: Parameters<typeof qrcode>[1];
	encoding: NonNullable<Parameters<ReturnType<typeof qrcode>["addData"]>[1]>;
	content: string;
	quietZoneModules: number;
	fallbackModulePixels: number;
};

export const contactConfig = {
	objectUrlLifetimeMs: 1500,
};
